import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { DynamicFormService } from '../../services/dynamic-form/dynamic-form.service';
import { DynamicForm } from '../../models/dynamic-form.model';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-dynamic-forms',
  standalone: true,
  imports: [CommonModule, CardModule, ButtonModule, ConfirmDialogModule, ToastModule, TooltipModule],
  providers: [ConfirmationService, MessageService],
  templateUrl: './dynamic-forms.component.html',
  styleUrl: './dynamic-forms.component.scss'
})
export class DynamicFormsComponent implements OnInit {
  forms$!: Observable<DynamicForm[]>;

  constructor(
    private formService: DynamicFormService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.loadForms();
  }

  loadForms() {
    this.forms$ = this.formService.getForms();
  }

  createNewForm() {
    this.router.navigate(['/admin/dynamic-forms/create']);
  }

  editForm(id: string) {
    this.router.navigate(['/admin/dynamic-forms/edit', id]);
  }

  toggleStatus(event: Event, form: DynamicForm) {
    const action = form.isActive ? 'deactivate' : 'activate';
    
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Are you sure you want to ${action} this form?`,
      header: `Confirm ${action === 'activate' ? 'Activation' : 'Deactivation'}`,
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: "none",
      rejectIcon: "none",
      rejectButtonStyleClass: "p-button-text",
      accept: () => {
        const obs = form.isActive ? this.formService.deactivateForm(form.id) : this.formService.activateForm(form.id);
        obs.subscribe(() => {
          this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: `Form ${form.isActive ? 'deactivated' : 'activated'} successfully` });
          this.loadForms(); // Refresh the list
        });
      }
    });
  }
}
